//Use this class as a model for future services.
//No Custom Repository Class is required 

import { SupportTicket } from "../entities/entities";
import { EntityManager, Repository } from "aurelia-orm";
import { autoinject } from 'aurelia-dependency-injection';

@autoinject()
export class SupportTicketService {
    getOpenQueueTickets(): any {
		return this.repository.find("get-open-queue-tickets");
    }
    getClosedQueueTickets(): any {
		return this.repository.find("get-closed-queue-tickets");
    }
    closeTicket(id: number): any {
        return this.repository.find(`close-ticket?id=${id}`)
    }
       
	repository: Repository;
	constructor(private entityManager: EntityManager) {
		this.repository = this.entityManager.getRepository(SupportTicket);
	}
	
	getOpenTickets() {
		return this.repository.find("get-open-tickets");

	}

	getClosedTickets() {
		return this.repository.find("get-closed-tickets");
	}

	getTicket(id:number) {
		return this.repository.find(`get-ticket?id=${id}`);
	}


}